<template>
  <div class="login-bg">
    <div class="banner">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div style="height:100px;">
            <!-- <img class="p-5" src="../assets/image/home/LOGO_CTU.svg" alt=""> -->
          </div>
        </div>
        <div class="row login mx-2">
          <div class="col-md-6 col-12 align-self-center">
            <div>
              <img style="width: 80%;" src="../assets/image/LAL/LAL_login_LOGO_L.svg" alt="">
              <div v-if="!isLogin" class="mt-5 form-box">
                <form class="mt-4 px-4">
                  <div class="group">
                    <input v-on:keyup.enter="login" v-model="auth.account" type="text" required>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label>請輸入電子信箱..</label>
                  </div>
                  <div class="group">
                    <input v-on:keyup.enter="login" v-model="auth.password" type="password" required>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label>請輸入密碼...</label>
                  </div>
                  <button type="button" style="width:100%;background: #4045DC; color:#fff;" class="btn" @click="login">登入</button>
                </form>
                <div class="mt-3">
                  使用人次: {{this.count}}
                </div>
              </div>
              <div v-else>
                  <div class="my-5 form-box">
                    歡迎您,
                  <div>
                    {{auth.account}}
                  </div>
                </div>
                <div class="main-title">請點選要前往學習的地方</div>
                <div class="d-flex justify-content-center">
                  <img style="width:250px;" class="mx-2 pointer" @click="goPage('LS')" src="../assets/image/LAL/LAL_login_btn_LS.svg" alt="">
                  <img style="width:250px;" class="mx-2 pointer" @click="goPage('AI')" src="../assets/image/LAL/LAL_login_btn_AI.svg" alt="">
                  <img style="width:250px;" class="mx-2 pointer" @click="goPage('Story')" src="../assets/image/LAL/LAL_login_btn_Story.svg" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 align-self-center"></div>
        </div>
      </div>
    </div>
    <div class="topic-banner py-5">
      <div class="container">
        <div class="row">
          <div class="col-12 mx-auto">
            <h2 class="title">多元學習主題</h2>
          </div>
          <div></div>
          <div class="col-md-6">
            <img style="width:100%;" src="../assets/image/home/topic/pic_01.svg" alt="">
          </div>
          <div class="col-md-6">
            <img style="width:100%;" src="../assets/image/home/topic/pic_02.svg" alt="">
          </div>
          <div class="col-md-6 mt-2">
            <img style="width:100%;" src="../assets/image/home/topic/pic_03.svg" alt="">
          </div>
          <div class="col-md-6 mt-2">
            <img style="width:100%;" src="../assets/image/home/topic/pic_04.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="feature-banner py-5">
      <div class="container">
        <div class="row">
          <div class="mx-auto col-12">
            <h2 class="title">全新學習架構</h2>
          </div>
          <div class="col-md-6">
            <img style="width:100%;" src="../assets/image/home/feature/pic_05.svg" alt="">
          </div>
          <div class="col-md-6">
            <h2 class="title">AI語音評析六大指標</h2>
            <div class="feature-box">
              運用AI系統量化分析使用者錄音音訊的<span class="red-text">發音</span>、<span class="red-text">節奏</span>、<span class="red-text">音量</span>、<span class="red-text">語數</span>、<span class="red-text">斷點</span>和<span class="red-text">語調</span>，與標準音檔進行聲波比對，演算判讀快速，回饋評比明確，即時提供改進建議，立即修正反覆練習，養成自然語感，越說越流利！
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container" :class="{'footer-rwd': this.$route.name === 'CourseLesson'}">
        <div class="row">
          <div class="col-12">
            <div class="footer-info">
              <span>客服電話: (02)2660-0608 分機207</span> |
              <span>客服時間: 週一至週五: 09:00~18:00</span> |
              <span>客服信箱: mary_wang@liveabc.com</span>
            </div>
            Copyright©Hebron Soft Limited. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import api from '../store/api'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      // toggle: false,
      auth: {
        account: '',
        password: ''
      },
      isLogin: false,
      groupList: {},
      count: 0
    }
  },
  props: {
    assistData: {
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'authorized'
    ])
  },
  mounted () {
    this.getLoginCount()
    if (this.authorized) {
      this.$router.push({  name: 'Search' })
    }
  },
  methods: {
    ...mapActions({
      dologin: 'login',
      getUser: 'getUser',
    }),
    //下拉選單改為，一次出現五個選項
    async login () {
      const vm = this
      try {
        await this.dologin({ email: this.auth.account, password: this.auth.password }).then((res) => {
          if (res.groups) {
            let groupsList = {}
            for (let i = 0; i < res.groups.length; i++) {
              groupsList[res.groups[i].id] = res.groups[i].name
            }
            vm.$swal({
              title: '選擇班級',
              input: 'select',
              inputOptions: groupsList,
              showCancelButton: false,
              inputPlaceholder: '請選擇班級',
              customClass: {
                input: 'my-select'
              },
              inputValidator: function(value) {
                if (value) {
                  return new Promise(function(resolve, reject) {
                    api.post(`/me/groups/${value}`)
                    resolve()
                    vm.getUser()
                    vm.isLogin = true
                    // vm.$router.push({ name: 'Search' })
                  })
                } else {
                  vm.$swal({
                    title: '請選擇班級',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: '確定'
                  })
                }
              }
            })
          } else {
            vm.isLogin = true
            // this.$router.push({ name: 'Search' })
          }
        })
        await this.getUser()
      } catch (error) {
        if (error) {
          console.log(error)
          this.$swal({
            title: '登入失敗',
            text: error.response.data.message,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: '確定'
          })
        }
        // console.error(error.response.data)
      }
    },
    goPage (el) {
      if (el === 'LS') {
        this.$router.push({  name: 'Search' })
      } else if (el === 'AI') {
        this.$router.push({  name: 'AI_Home' })
      } else if (el === 'Story') {
        const storeAuth = this.$store.getters.auth
        const token = storeAuth && storeAuth.user && storeAuth.user.token
        const url = new URL('https://imaker.liveabc.com/ai_book')
        if (token) {
          url.searchParams.set('token', token)
        }
        window.location.href = url.toString()
      }
    },
    // async login () {
    //   const vm = this
    //   try {
    //     await this.dologin({ email: this.auth.account, password: this.auth.password }).then((res) => {
    //       if (res.groups) {
    //         let groupsList = {}
    //         for (let i = 0; i < res.groups.length; i++) {
    //           groupsList[res.groups[i].id] = res.groups[i].name
    //         }
    //         vm.$swal({
    //           title: '選擇班級',
    //           input: 'select',
    //           inputOptions: groupsList,
    //           showCancelButton: true,
    //           customClass: {
    //             input: 'my-select'
    //           },
    //           inputValidator: function(value) {
    //             return new Promise(function(resolve, reject) {
    //               api.post(`/me/groups/${value}`)
    //               resolve()
    //               vm.getUser()
    //               vm.$router.push({ name: 'Search' })
    //             })
    //           }
    //         })
    //       } else {
    //         this.$router.push({ name: 'Search' })
    //       }
    //     })
    //     await this.getUser()
    //   } catch (error) {
    //     if (error) {
    //       console.log(error)
    //       this.$swal({
    //         title: '登入失敗',
    //         text: error.response.data.message,
    //         icon: 'error',
    //         showCancelButton: false,
    //         confirmButtonText: '確定'
    //       })
    //     }
    //     // console.error(error.response.data)
    //   }
    // },
    getChannel () {
      this.getChannels()
    },
    async getLoginCount () {
      const { data } = await api.get(`/login/count`)
      if (data.status === 'Success') {
        this.count = data.data.count
      }
    },
  },
  components: {
    // Video
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .group {
    position:relative;
    margin-bottom: 35px;
  }
  input {
    font-size: 18px;
    padding: 10px 10px 10px 5px;
    display: block;
    width: 100%;
    border: none;
    border-bottom: 1px solid #757575;
  }
  input:focus	{ outline: none; }
  .my-select {
    margin: 5% auto !important;
  }

  /* LABEL ======================================= */
  label {
    color: #999;
    font-size: 18px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 10px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }

  /* active state */
  input:focus ~ label, input:valid ~ label {
    top: -20px;
    font-size: 14px;
    color: #000000;
  }
  .arrow {
    width: 50px;
  }
  /* BOTTOM BARS ================================= */
  .bar {
    position:relative;
    display:block;
    width:100%;
  }
  .bar:before, .bar:after {
    content: '';
    height: 2px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: #000000;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }
  .bar:before {
    left: 50%;
  }
  .bar:after {
    right: 50%;
  }

  /* active state */
  input:focus ~ .bar:before, input:focus ~ .bar:after {
    width: 50%;
  }
  .underLine {
    text-decoration: underline;
  }
  .banner {
    background-repeat: no-repeat;
    background-size: cover;
    // width:100%;
    // background-size:100% 100%;
    background-position: center;
    background-image: url('../assets/image/LAL/LAL_login_bg.jpg');
    .container-fluid {
      height: 100vh;
      .login {
        text-align: center;
        height: 70%;
        .form-box {
          border: #4045DC solid 1px;
          box-shadow: #4045DC  0px 5px 15px;
          border-radius: 20px;
          padding: 20px;
          background-color: #fff;
          min-width: 250px;
          width: 60%;
          margin: auto;
        }
        .title {
          color: black;
          margin-top: 20px;
          font-size: 3rem;
          font-weight: 1000;
        }
        .main-title {
          color: #4045DC;
          font-weight: bolder;
          font-size: 1.25rem;
          margin: 20px auto;
        }
      }
    }
  }
  .topic-banner {
    background-image: url('../assets/image/home/bg_theme_L.jpg');
    .title {
      color: black;
      margin-top: 20px;
      font-size: 2.5rem;
      font-weight: 1000;
    }
  }
  .feature-banner {
    padding: 200px 0;
    background-image: url('../assets/image/home/bg_info_M.jpg');
    .title {
      color: black;
      margin: 20px 0;
      font-size: 2.5rem;
      font-weight: 1000;
    }
    .feature-box {
      margin: auto;
      width: 70%;
      font-size: 1.25rem;
      .red-text {
        color: red;
      }
    }
  }
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
  @media screen and (max-width: 600px) {
    .form-box {
      width: 100% !important;
    }
    .banner {
      background-image: url('../assets/image/LAL/LAL_login_bg_M.jpg');
    }
  }
  .footer {
    padding: calc(4vh - 12px);
    background-color: black;
    min-height: 8vh;
    color: $white-color;
    position: relative;
    text-align: center;
  }
</style>
